import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syskb { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '日期 (KB001) 不可空白'}) 
    @MaxLength(8,{message: '日期 (KB001) 資料太長'})
    KB001: string = '';            // 日期 8 

    @IsNotEmpty({message: '時間 (KB002) 不可空白'}) 
    @MaxLength(4,{message: '時間 (KB002) 資料太長'})
    KB002: string = '';            // 時間 4 

    @MaxLength(1,{message: '重要性 (KB003) 資料太長'})
    KB003: string = '3';            // 重要性 1 [DEF:"3"] 1:極重要 2:重要 3:普通

    @MaxLength(10,{message: '員工代號 (KB004) 資料太長'})
    KB004: string = '';            // 員工代號 10 

    @MaxLength(10,{message: '發佈人 (KB005) 資料太長'})
    KB005: string = '';            // 發佈人 10 

    @MaxLength(255,{message: '訊息 (KB006) 資料太長'})
    KB006: string = '';            // 訊息 255 

    @MaxLength(100,{message: '群組代號 (KB007) 資料太長'})
    KB007: string = '';            // 群組代號 100 空白表全部

    @MaxLength(8,{message: '失效日期 (KB008) 資料太長'})
    KB008: string = '';            // 失效日期 8 

    @MaxLength(255,{message: '網址 (KB009) 資料太長'})
    KB009: string = '';            // 網址 255 

    @MaxLength(1,{message: '需簽收 (KB010) 資料太長'})
    KB010: string = 'N';            // 需簽收 1 [DEF:"N"]

    @MaxLength(100,{message: '地區代號 (KB011) 資料太長'})
    KB011: string = '';            // 地區代號 100 1010810 ADD


}
